import Vue from 'vue'
//import App from './App.vue'
//import router from './router'
require('es6-promise').polyfill();

import VueI18n from 'vue-i18n';
import messages from './lang';
Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages
});

/*
import UIkit from 'uikit'
import Icons from '../../node_modules/uikit/dist/js/uikit-icons'
UIkit.use(Icons)
window.UIkit = UIkit;
*/
//window._ = require('lodash');

//import VeeValidate from 'vee-validate';

//Vue.use(VeeValidate, { inject: true });

import StarRating from 'vue-star-rating'

import AnsolutionForm from './components/form-tailwind.vue'
import AutoropaShopModels from './components/ShopModels.vue'
import FinanceCalculator from './components/Financing.vue'
import SpecialEquipment from './components/SpecialEquipment.vue'
import AnsolutionFeedback from './components/Feedback.vue'
import AddParkButton from './components/AddParkButton.vue'
import FormModal from './components/FormModal.vue'
import ExchangeRate from './components/ExchangeRate.vue'


Vue.config.productionTip = false

/* eslint-disable no-new */
const vm = new Vue({
  el: '#vue',
  i18n,
  components: {
    //AnsolutionForm,
    AutoropaShopModels,
    FinanceCalculator,
    SpecialEquipment,
    AnsolutionFeedback,
    StarRating,
    AddParkButton,
    FormModal,
    ExchangeRate
  }
})

const vmForm = new Vue({
  el: '#hasForm',
  i18n,
  components: {
    AnsolutionForm
  }
})
